import { Link } from "react-router-dom";

export default function LegalStub({ title }) {
  return (
    <div className="pt-40 pb-24 bg-messinger-bg" data-testid={`legal-${title.toLowerCase()}`}>
      <div className="container-x max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-8 bg-messinger-orange" />
          <span className="label-eyebrow">{title}</span>
        </div>
        <h1 className="font-heading font-semibold text-white text-4xl lg:text-5xl leading-tight">
          {title}
        </h1>
        <p className="mt-6 text-white/70 leading-relaxed">
          Diese Seite wird in Kürze ergänzt. Für rechtliche Anfragen erreichen
          Sie uns über das{" "}
          <Link to="/kontakt" className="text-messinger-orange underline underline-offset-4">
            Kontaktformular
          </Link>{" "}
          oder unter den im Footer angegebenen Daten.
        </p>
      </div>
    </div>
  );
}
